module.exports = __webpack_public_path__ + "img/icon-textarea.87708bb0.svg";